import { COLORS } from 'constants/index';

export const MuiDialog = {
  paperWidthXs: {
    maxWidth: '384px',
  },
};

export const MuiDialogContent = {
  root: {
    padding: '0 24px',
    '&:first-child': {
      paddingTop: '0',
    },
  },
};

export const MuiDialogActions = {
  root: {
    padding: '8px',
    borderTop: `1px solid ${COLORS.GRAY_08}`,
  },
};
